import SEO from "@/components/common/seo/SEO";

export default function App() {
  return (
    <>
      <SEO
        title="Forte Estate Advisory | Frisco, TX"
        description="Estate advisory services in Frisco and the Dallas-Fort Worth area."
      />
      <main className="min-h-screen bg-white text-slate-900">
        <section className="mx-auto max-w-3xl px-6 py-24">
          <h1 className="text-4xl font-semibold tracking-tight">
            Forte Estate Advisory
          </h1>
          <p className="mt-6 text-lg text-slate-600">
            Site launching soon. Serving Frisco and the greater Dallas-Fort Worth
            area.
          </p>
          <p className="mt-10 text-sm text-slate-500">Frisco, Texas</p>
        </section>
      </main>
    </>
  );
}